import React from 'react';
import Label from '@/components/Label';
import Input from '@/components/Input/Input';
import Button, { ButtonSizes, ButtonVariants } from '@/components/new-design/Button';
import LoadingSpinner from '@/components/LoadingSpinner/LoadingSpinner';
import ErrorText from '@/components/ErrorText';
import { formatCurrency } from '@/pages/table/utils/utils';
import tetherpurple from '../../../assets/tetherpurple.svg';
import { UseFormRegister } from 'react-hook-form';
import { Token } from './TokensTab';

interface TransferFundsBoxProps {
  isValid: boolean;
  state: {
    loading: boolean;
  };
  onClose: () => void;
  loadingLabel: string;
  balance: number;
  register: UseFormRegister<any>;
  errors: {
    amount?: {
      message?: string;
    };
  };
  token?: Token;
}

const TransferFundsBox: React.FC<TransferFundsBoxProps> = ({
  isValid,
  state,
  onClose,
  loadingLabel,
  balance,
  register,
  errors,
  token,
}) => {
  return (
    <div className="flex w-full flex-col gap-6">
      <div
        className="flex w-full flex-col gap-3 rounded-lg border-[1px] border-ph-white-10 bg-ph-white-3 p-6 text-white"
        style={{ borderRadius: 20 }}
      >
        <div className="flex w-full items-center justify-between">
          <Label className="text-white" semiBold>
            Amount
          </Label>
          <div className="text-right text-sm font-semibold leading-[19px] text-ph-white-30">
            Bal: ${formatCurrency(Number(balance))}
          </div>
        </div>
        <div className="relative flex justify-between">
          <div className="flex w-full flex-col">
            <Input
              placeholder="0.00"
              {...register('amount')}
              error={!!errors.amount}
              type="number"
              step="0.001"
              className="w-full text-xl font-semibold text-ph-dirty-white"
              min={0}
              lang="en"
            />
            {errors.amount?.message && <ErrorText>* {errors.amount.message}</ErrorText>}
          </div>

          <div className="absolute left-[34.6em] top-0 flex w-full translate-y-1/2 items-center text-sm font-semibold leading-[19px] text-white">
            <img src={token ? token.img : tetherpurple} alt="USDT" className="mr-3 h-7 w-7" />
            <div className="flex flex-col">
              <span>{token ? token.label : 'Tether'}</span>
              <span className="text-xs leading-5 text-ph-gray-evening">Polygon</span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <Button disabled={!isValid || state.loading} variant={ButtonVariants.primary} size={ButtonSizes.lg}>
          {state.loading ? (
            <span className="flex items-center gap-2">
              <LoadingSpinner size="5" /> {loadingLabel}
            </span>
          ) : (
            'Transfer Funds'
          )}
        </Button>
        <Button onClick={onClose} variant={ButtonVariants.secondary} size={ButtonSizes.lg}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default TransferFundsBox;
